<template>
  <div>
    <!-- <b-card title="Kick start your project 🚀">
      <b-card-text>All the best for your new project.</b-card-text>
      <b-card-text>Please make sure to read our <b-link
        href="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/"
        target="_blank"
      >
        Template Documentation
      </b-link> to understand where to go from here and how to use our template.</b-card-text>
    </b-card> -->

    <!-- <b-card title="Want to integrate JWT? 🔒">
      <b-card-text>We carefully crafted JWT flow so you can implement JWT with ease and with minimum efforts.</b-card-text>
      <b-card-text>Please read our  JWT Documentation to get more out of JWT authentication.</b-card-text>
    </b-card> -->

    <b-card title="Sistem Administrasi Perkantoran KAN-Jabung">
      <b-card-text>Selamat Datang <b> {{ data }} </b> </b-card-text>
    </b-card>

    <b-row class="match-height">
      <b-col md="6">
        <analytics-support-tracker :data="dataDispo" />
      </b-col>
      <b-col md="6">
        <analytics-support-tracker :data="dataAssignment" />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col md="6">
        <analytics-support-tracker :data="dataRequest" />
      </b-col>
    </b-row>

    <!-- <b-row class="match-height">
      <b-col md="4">
        <EcommerceGoalOverview :data="diagram" />
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
/* eslint-disable no-unused-vars */
import {
  BCard, BCardText, BLink, BCol, BRow,
} from 'bootstrap-vue'
import store from '@/store/index'
import axios from '@axios'
import EcommerceGoalOverview from './components/EcommerceGoalOverview.vue'
import AnalyticsSupportTracker from './components/AnalyticsSupportTracker.vue'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
    BCol,
    BRow,
    EcommerceGoalOverview,
    AnalyticsSupportTracker,
  },

  data() {
    return {
      data: {},
      dataDisposisi: {},
      diagram: {
        completed: '786,617',
        inProgress: '13,561',
        series: [83],
      },
      dataDispo: {
        title: '',
        labels: [],
        lastDays: [],
        totalTicket: 0,
        newTicket: 0,
        openTicket: 0,
        responseTime: 0,
        supportTrackerRadialBar: {
          series: [0],
        },
      },

      dataAssignment: {
        title: '',
        labels: [],
        lastDays: [],
        totalTicket: 0,
        newTicket: 0,
        openTicket: 0,
        responseTime: 0,
        supportTrackerRadialBar: {
          series: [0],
        },
      },

      dataRequest: {
        title: '',
        labels: [],
        lastDays: [],
        totalTicket: 0,
        newTicket: 0,
        openTicket: 0,
        responseTime: 0,
        supportTrackerRadialBar: {
          series: [0],
        },
      },
    }
  },

  created() {
    this.data = store.state.userData.data.name
    this.getAssignment()
    this.getDispo()
    this.getRequest()
  },

  methods: {
    async getAssignment() {
      const { data } = await axios.get('/siap/assignment/summary')
      let total = (data.open / data.total) * 100
      if (Number.isNaN(total)) {
        total = 0
      }

      this.dataAssignment = {
        title: 'Perintah',
        labels: ['Completed Perintah'],
        lastDays: ['Last 28 Days', 'Last Month', 'Last Year'],
        totalTicket: data.total,
        newTicket: data.open,
        openTicket: data.closed,
        responseTime: 1,
        supportTrackerRadialBar: {
          series: [total.toFixed(2)],
        },
      }

      //  catch (err) {
      //   console.error(err)
      // }
    },

    async getDispo() {
      const { data } = await axios.get('/siap/disposition/summary')
      let total = (data.open / data.total) * 100
      if (Number.isNaN(total)) {
        total = 0
      }

      this.dataDispo = {
        title: 'Disposisi',
        labels: ['Completed Disposisi'],
        lastDays: ['Last 28 Days', 'Last Month', 'Last Year'],
        totalTicket: data.total,
        newTicket: data.open,
        openTicket: data.closed,
        responseTime: 1,
        supportTrackerRadialBar: {
          series: [total.toFixed(2)],
        },
      }
    },

    async getRequest() {
      const { data } = await axios.get('/siap/request/summary')
      let total = (data.open / data.total) * 100
      if (Number.isNaN(total)) {
        total = 0
      }

      this.dataRequest = {
        title: 'Request',
        labels: ['Completed Request'],
        lastDays: ['Last 28 Days', 'Last Month', 'Last Year'],
        totalTicket: data.total,
        newTicket: data.open,
        openTicket: data.closed,
        responseTime: 1,
        supportTrackerRadialBar: {
          series: [total.toFixed(2)],
        },
      }
    },
  },
}
</script>

<style>
</style>
